module.exports = __webpack_public_path__ + "static/img/widget-middle.6679102.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/widget/widget-middle.png
// module id = i1EX
// module chunks = 2